import { create } from 'zustand';

type Species = 'dog' | 'cat';
type SpeciesWithAnyCasing = Species | Capitalize<Species>;

export interface PageGlobalContext {
  /**  Casing may be inconsistent in CMS */
  species?: SpeciesWithAnyCasing;
  brand?: string;
}

interface PageStore {
  page: PageGlobalContext;
  setPage: (page: PageGlobalContext) => void;
}

export const usePageStore = create<PageStore>()(set => ({
  page: {},
  setPage: context => set({ page: context }),
}));
